/** @format */

import { selectErrorList, selectSelectedAttributeOptions } from '@pdp/attributes/data-access';
import { Component, computed, input } from '@angular/core';
import {
	homefieldIconAlertInfoFilled,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

import { BaseAttributeLabelComponent } from '../base-attribute-label/base-attribute-label.component';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { SkuAttribute } from '@shared/data-access/interfaces';

@Component({
	selector: 'pdp-attributes-components-label',
	templateUrl: './attribute-label.component.html',
	standalone: true,
	imports: [CommonModule, HomefieldIconLibraryModule, BaseAttributeLabelComponent],
	providers: [HomefieldIconsLibraryService]
})
export class AttributeLabelComponent {
	selectedAttributes = this.store.selectSignal(selectSelectedAttributeOptions);
	public selectErrors$ = this.store.select(selectErrorList);

	readonly attributeGroupName = input<string>();
	readonly index = input<number>();
	readonly selectedBucketIndex = input<number>();
	readonly bucket = input<SkuAttribute>();

	selectedAttribute = computed(() => {
		const matchingAttribute = this.selectedAttributes().find(
			(attr) => attr?.name === this.attributeGroupName()
		);
		if (
			!this.bucket() ||
			(matchingAttribute &&
				this.bucket().bucket.defAttributes.property.some(
					(attrProperty) =>
						attrProperty?.name === this.attributeGroupName() &&
						attrProperty?.value === matchingAttribute.value
				))
		) {
			return matchingAttribute;
		}
	});

	constructor(
		private store: Store,
		private homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoFilled]);
	}
}
